import { SortableHandle } from "react-sortable-hoc";

const DragHandle = SortableHandle(() => {
  return <div className="drag-icon">⠿</div>;
});

export default DragHandle;

DragHandle.propTypes = {};
